"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _OptInFlowContainerModal = _interopRequireDefault(require("./OptInFlowContainerModal"));

var GmailInboxConnectOptInFlowContainerModal = function GmailInboxConnectOptInFlowContainerModal(props) {
  return _react.default.createElement(_OptInFlowContainerModal.default, Object.assign({}, props, {
    langKey: "gmail"
  }));
};

GmailInboxConnectOptInFlowContainerModal.propTypes = Object.assign({}, _PromptablePropInterface.default, {
  allowRequestGroup: _propTypes.default.string.isRequired
});
var _default = GmailInboxConnectOptInFlowContainerModal;
exports.default = _default;
module.exports = exports.default;